// extracted by mini-css-extract-plugin
export var feed__item = "Feed-module--feed__item--619ca";
export var feed__itemDescription = "Feed-module--feed__item-description--be821";
export var feed__itemMeta = "Feed-module--feed__item-meta--40cc8";
export var feed__itemMetaCategoryLink = "Feed-module--feed__item-meta-category-link--0d2d9";
export var feed__itemMetaTime = "Feed-module--feed__item-meta-time--a7603";
export var feed__itemReadmore = "Feed-module--feed__item-readmore--3a66e";
export var feed__itemTitle = "Feed-module--feed__item-title--3920d";
export var feed__itemTitleLink = "Feed-module--feed__item-title-link--37758";